export const APP_CONFIG = {
  apiUrl: 'https://bristol.openplace.directory/o/ServiceDirectoryService/v2/',
  searchType: 'Change',
  favouriteUrl: 'https://www.wellaware.org.uk/wp-admin/admin-ajax.php',
  siteUrl: 'https://www.wellaware.org.uk/',
  siteName: 'Wellaware',
  siteLogoPath:
    'https://www.wellaware.org.uk/wp-content/themes/wellaware-2020/dist/images/wellaware-logo.svg',
  wordpressFeedUrl: 'https://www.wellaware.org.uk/wp-json/wp/v2/pages/476',
  gTag: 'G-6FWRD1RS3G',
}
export default APP_CONFIG
